var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00088501,
    width: 56,
    height: 56,
    rx: 5.27855,
    fill: "#F77E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6202 13.1963H14.3816C13.7265 13.1963 13.1973 13.7255 13.1973 14.3806V41.6193C13.1973 42.2743 13.7265 42.8036 14.3816 42.8036H41.6202C42.2753 42.8036 42.8045 42.2743 42.8045 41.6193V14.3806C42.8045 13.7255 42.2753 13.1963 41.6202 13.1963ZM40.1399 30.3685H28.593V25.6314H40.1399V30.3685ZM40.1399 40.1389H15.8619V15.8609H40.1399V23.2628H27.4087C26.7537 23.2628 26.2245 23.792 26.2245 24.4471V31.5528C26.2245 32.2078 26.7537 32.7371 27.4087 32.7371H40.1399V40.1389ZM30.5175 27.9999C30.5175 28.3925 30.6735 28.769 30.9511 29.0467C31.2287 29.3243 31.6053 29.4803 31.9979 29.4803C32.3905 29.4803 32.7671 29.3243 33.0447 29.0467C33.3223 28.769 33.4782 28.3925 33.4782 27.9999C33.4782 27.6073 33.3223 27.2307 33.0447 26.9531C32.7671 26.6755 32.3905 26.5196 31.9979 26.5196C31.6053 26.5196 31.2287 26.6755 30.9511 26.9531C30.6735 27.2307 30.5175 27.6073 30.5175 27.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBank);
export default __webpack_public_path__ + "static/media/editBank.d1cebdb4980339477c5efe7482d89f66.svg";
export { ForwardRef as ReactComponent };